module.exports = __webpack_public_path__ + "files/f6ef454bc3d55bb90950205aff9d3d9a.png";